import React, { Fragment, useState, useEffect, useRef, useMemo, useCallback } from "react"
import _ from "lodash"
import { useTranslation } from "react-i18next"
import Header from "../../components/Header"
import SearchTimeline from "../../components/timeline/SearchTimeline"
import { showAlertAction, hideAlertAction } from "../../actions/alertActions"
import { useDispatch, useSelector } from "react-redux"
import { Redirect } from "react-router-dom"
import FiltersDocuments from "../../components/documents/FiltersDocuments"
import ElementsListDocuments from "../../components/documents/ElementsListDocuments"
import { ViewAllDocumentsList, FiltersAllDocuments } from "../../components"
import { AllDocumentsList } from ".."
import ConceptsTable from "../../components/documents/ConceptsTable"
import LineChart from "../../components/timeline/LineChart"
import ChartTimeline from "../../components/timeline/Chart"
import {
	searchForTopicAPI,
	sendSaveToAPI,
	setCurrentFilter,
	getSavedBuildConceptsOnAPI,
	setCurrentUUID,
	loadDocumentsOfConcept,
	requestSavedBuildConcepts,
	loadDocumentsOfConceptWithDocsClear,
} from "../../actions/buildconceptActions"
import uuid from "react-uuid"
import {
	loadConceptFromAPI,
	setLoader,
	loadSearchFromAPI,
	getAllDocumentsRequest,
	getAllDocumentsInBackgroundRequest,
	getAllDocumentsInBackgroundRequestSuccess,
	setExpandGraph,
} from "../../actions/viewdocumentsActions"
import axios from "axios"
import SideMenu from "../../components/menu/SideMenu"
import { sourceHelper } from "../../helpers/sourceHelper"
import { requestSources } from "../../actions/sourcesActions"

//Redux actions
import { newSearchSearch } from "../../actions/searchActions"
import {
	updateViewDocumentsHighlight,
	updateViewDocumentsSavedTags,
	updateViewDocumentsSavedTagsExclude,
} from "../../actions/highlightActions"
import { requestCustomTags } from "../../actions/customTagsActions"
import { deleteSearchLoad, deleteSearchReset, saveInitSearchSagas, saveNewSearchFailedClear } from "../../actions/savedSearchActions"
import {
	GET_ALL_DATA_INTERVAL,
	parsePayload,
	useInterval,
	usePrevious,
	useFilters,
	searchTermParse,
	searchTermDeparse,
	LOCAL_STORAGE_KEYS,
	removeFileIdFromLocalStorage,
	getQueryParams,
	buildQueryString,
	GRAPH_DATE_OPTIONS,
	PAYLOAD_DATE_FORMAT,
} from "../../utils"

/****************Ragnar Lodbrok****************/
import moment from "moment"
import {
	Box,
	Button,
	ButtonGroup,
	Collapse,
	Drawer,
	FormControlLabel,
	Grid,
	IconButton,
	Paper,
	Slide,
	Switch,
	Tab,
	Tooltip,
	Typography,
} from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { getFromEmails, getToEmails, getUsers, getSources, getRetainFiltersList, getRetainFiltersSuccess } from "../../actions/infoActions"
import { FileTypes, DropdownWithSearch, DateRange, Tags, CommentsBy, View, Reset, SortByRelevance } from "../../components/Filters"
import WithDrawer from "../../components/common/drawer/withDrawer"
import { AllDocuments, ToolbarDropdown } from "../../components/ViewDocumentsTypes"
import { setCurrentSearchAction } from "../../actions/currentSearchActions"
import Notification from "../../components/Notification/Notification"
import { setFilterData, showDuplicateAction, showDuplicateActionReset } from "../../actions/filterActions"
import ConceptDropdown from "../../components/ViewDocumentsTypes/ToolbarDropdown/ConceptDropdown"
import SearchSection from "../../components/ViewDocumentsTypes/ToolbarDropdown/SearchSection"
import FilesList from "../../components/search/FilesList"
import FiltersSearch from "../../components/search/FiltersSearch"
import ListSVG from "../../components/icons/ListSVG"
import { DocSVG } from "../../components/icons"
import { useHistory, useLocation } from "react-router-dom"
import { resetPageViewerData } from "../../actions/documentModalActions"
import { saveNewSearch } from "../../actions/savedSearchActions"
import { setNotification } from "../../actions/notificationActions"
import { setSelectedSearch as setSelectedSearchAction } from "../../actions/searchActions"
import { ReviewDropdown } from "../../components/Reviews"
import {
	getReviewRequest,
	isReviewUpdateTrigger,
	reSetReview,
	resetReviewForm,
	setIsCaseAdmin,
	setReview,
	setReviewFormOpen,
	setReviewRestrictIds,
	updateReviewMetada,
} from "../../actions/reviewActions"
import ConfirmationDialog from "../../components/common/dialog/ConfirmationDialog"
import { resetSelectedIdsAction } from "../../actions/downloadsActions"
import { updateTaggedDateReset } from "../../actions/taggedDateActions"
import { ModalPopup } from "../../components/modal"
import FileDeleteModal from "../../components/common/FileDeleteModal"
import { reloadList, setIsFileDeleted } from "../../actions/deleteActions"
import ArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"
import ArrowUpIcon from "@material-ui/icons/KeyboardArrowUp"
import ArrowRightIcon from "@material-ui/icons/ChevronRight"
import CloseIcon from "@material-ui/icons/Close"
import EventNoteIcon from "@material-ui/icons/EventNote"
import TimelineIcon from "@material-ui/icons/Timeline"
import ExportSVG from "../../components/icons/ExportSVG"
import { checkNameAlreadyExistFailed, getGraphDataRequest } from "../../actions/createTimelineActions"
import TimelineChart from "../CreateTimeline/TimelineChart"
import PropTypes from "prop-types"
import Tabs from "@material-ui/core/Tabs"

// import { TabPanel } from "@material-ui/lab"
import Events from "../../components/timeline/Events"
import SavedSearchDateRange from "../../components/timeline/SavedSearchDateRange"
import CreateEvent from "../../components/event/CreateEvent"
import SaveDateRangeDialog from "../../components/common/dialog/SaveDateRangeDialog"
import { getEventsRequest, setEventFormOpen, setSelectedEvent } from "../../actions/eventActions"
import ExportEvent from "../../components/event/ExportEvent"

function TabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<div role="tabpanel" hidden={value !== index} id={`wrapped-tabpanel-${index}`} aria-labelledby={`wrapped-tab-${index}`} {...other}>
			{value === index && (
				<Box p={1}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
}

function a11yProps(index) {
	return {
		id: `wrapped-tab-${index}`,
		"aria-controls": `wrapped-tabpanel-${index}`,
	}
}

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
	},
	notification: {
		padding: theme.spacing(2, 10),
	},
	view: {
		display: "flex",
		alignItems: "center",
		justifyContent: "end",
		width: "100%",
	},
	btnGrp: {
		marginTop: "5px",
	},
	iconBtn: {
		width: "30px",
		height: "30px",
		maxWidth: "30px",
		borderRadius: "3px",
		border: `1px solid ${theme.palette.grey.P300}`,
		padding: 0,
		marginRight: "6px",
	},
	allDocWrapper: {
		display: "flex",
	},
	reviewWrapper: {
		display: "flex",
		alignItems: "center",
	},
	fileDeletedModal: {
		width: 400,
	},
	btnRefresh: {
		textTransform: "initial",
	},
	graphWrapper: {
		border: `1px solid ${theme.palette.grey["300"]}`,
		marginBottom: 50,
		position: "relative",
	},
	grpahMainContainer: {
		width: "36px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		border: "1px solid #e0e0e0",
		padding: "5px",
		position: "absolute",
		background: "#fff",
		bottom: "-22px",
		borderTop: "none",
		borderBottomLeftRadius: "18px",
		borderBottomRightRadius: "18px",
		height: "22px",
		// transition: "transform 0.3s ease-in-out",
		// "&:hover": {
		// 	animation: "$bounce 0.6s infinite alternate",
		// },
	},
	graphOverlay: {
		position: "absolute",
		width: "100%",
		top: "0",
		height: "75px",
		cursor: "pointer",
	},
	grpahExpandIcon: {
		position: "absolute",
		top: "-5px",
		cursor: "pointer",
		transition: "transform 0.3s ease-in-out",
		"&:hover": {
			animation: "$bounce 0.6s infinite alternate",
		},
	},
	rootDrawer: {
		position: "absolute",
		width: "100%",
		height: "100%",
		top: 0,
		right: 0,
		backgroundColor: `rgb(from ${theme.palette.grey["700"]} r g b / 50%)`,
	},
	wrapper: {
		display: "flex",
		position: "absolute",
		width: 420,
		height: "100%",
		right: 0,
		top: 0,
	},
	paper: {
		zIndex: 1,
		position: "relative",
		//margin: theme.spacing(1),
		paddingTop: theme.spacing(4),
	},
	tabs: {
		"& .MuiTab-root": {
			textTransform: "capitalize",
		},
	},
	tab: {
		//height: `calc(100vh - 15px)`,
	},
	button: {
		margin: theme.spacing(1),
		color: theme.palette.grey["D300"],
		textTransform: "capitalize",
		fontWeight: 500,
	},
	"@keyframes bounce": {
		"0%": {
			transform: "translateY(0)",
		},
		"100%": {
			transform: "translateY(-10px)",
		},
	},
}))

const getGraphPayload = (data) => {
	const {
		inputSearch,
		concept_id_list,
		filters,
		recordsPerPage,
		skipCount,
		sortModel,
		your_search_id,
		shared_search_id,
		additional_params,
		restrict_file_ids,
		showDuplicate,
		subject,
		expand_graph,
		grpahDate,
	} = data

	const searchTerms = inputSearch && inputSearch?.length > 0 ? searchTermParse(inputSearch) : []
	const payload = {
		text: searchTerms,
		categories: concept_id_list,
		neg_text: "",
		return_count: recordsPerPage,
		skip_count: skipCount,
		suppress_content: false,
		treat_like_concept: false,
		mode: "FILE",
		remove_duplicates: showDuplicate,
		additional_params: _.cloneDeep(additional_params),
		restrict_file_ids,
		...filters,
		...expand_graph,
		...grpahDate,
	}

	if (subject) {
		payload["subject"] = subject
	}

	if (your_search_id) {
		payload["your_search_id"] = your_search_id
	}
	if (shared_search_id) [(payload["shared_search_id"] = shared_search_id)]

	if (!!sortModel.length) {
		const sort = { field: sortModel[0].field, ordering: sortModel[0].sort === "asc" ? 1 : -1 }
		payload["sort"] = sort
	}

	return payload
}

const PageDocuments = () => {
	const [t] = useTranslation("global")
	const classes = useStyles()
	const history = useHistory()
	const theme = useTheme()
	/* ******************* REDUX STORE ******************* */
	// Redux actions
	const currentFilter = useSelector((state) => state.buildconcept.currentFilter)
	const searchTopic = (item) => dispatch(searchForTopicAPI(item))
	const currentSearchFilter = useSelector((state) => state.viewdocuments.sourceFilter)
	const dispatch = useDispatch()
	const location = useLocation()
	//Access store state
	const cargando = useSelector((state) => state.viewdocuments.loading)
	const alert = useSelector((state) => state.alert.alert)
	const isUserLogedInt = useSelector((state) => state.authtentication.loggedIn)
	const highlightFilter = useSelector((state) => state.highlightFilter.viewDocuments)
	const tags = useSelector((state) => state.highlightFilter.viewDocumentsTags)
	const tagsExclude = useSelector((state) => state.highlightFilter.viewDocumentsTagsExclude)
	const sourceApi = useSelector((state) => state.info?.sourcesList || [])
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const allDocumentsList = useSelector((state) => state.viewdocuments.allDocuments)
	const conceptsDocCount = useSelector((state) => state.viewdocuments.concept_docs.count)
	const { isApplyTagSuccess } = useSelector((state) => state.search)
	const { showDuplicate } = useSelector((state) => state.filter)
	/****************Ragnar Lodbrok****************/
	const savedConcepts = useSelector((state) => state?.buildconcept?.user_saved_build_concepts_unshared)
	const sharedConcepts = useSelector((state) => state?.buildconcept?.user_saved_build_concepts_shared)
	const searchesList = useSelector((state) => state?.savedSearch?.savedSearchs)
	const conceptsLoading = useSelector((state) => state?.buildconcept?.loading)
	const searchesLoading = useSelector((state) => state?.savedSearch?.loading)
	const filterJobId = useSelector((state) => state.filter?.filterJobId)
	const conceptDocs = useSelector((state) => state.viewdocuments.concept_docs)
	const users = useSelector((state) => state.info?.usersList)
	const retainedJobFailed = useSelector((state) => state.info?.retainedJobFailed)
	const selectedReview = useSelector((state) => state.review?.review)
	const isSearchDeleted = useSelector((state) => state?.savedSearch?.isDeleted)
	const searchDeletedId = useSelector((state) => state?.savedSearch?.deletedId)
	const isReviewFormOpen = useSelector((state) => state.review?.isReviewFormOpen)
	const allDocumentsCount = useSelector((state) => state.viewdocuments.allDocumentsCount)
	const isUpdateTrigger = useSelector((state) => state.review?.isUpdateTrigger)
	const is_case_admin = useSelector((state) => state.review?.is_case_admin)
	const isSearchSaved = useSelector((state) => state?.savedSearch?.isSaved)
	const isTaggedDateUpdated = useSelector((state) => state.taggedDateReducers?.isTaggedDateUpdated)
	const reviewList = useSelector((state) => state.review?.list)
	const subjectFilterData = useSelector((state) => state.filter?.subject)
	const isFileDeleted = useSelector((state) => state.deleteFile.isFileDeleted)
	const shouldReloadList = useSelector((state) => state.deleteFile.shouldReloadList)
	const editEvent = useSelector((state) => state.events.event)
	const openEventForm = useSelector((state) => state.events?.openEventForm)
	const graphData = useSelector((state) => state.timeline.graph)
	const expandGraph = useSelector((state) => state.viewdocuments.expandGraph)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// State
	const [currentSearchText, setCurrentSearchText] = useState("")
	const [resultSearch, saveResultSearch] = useState()
	const [requestNewDateSearch, setRequestNewDateSearch] = useState(false)
	// Filter for elements list
	const [elementsFilter, saveElementsFilter] = useState({
		coloursFilter: "",
		date: "",
	})
	const [filterList, setFilterList] = useState(sourceHelper.getFilter(sourceApi))
	const [tagsList, setTagsList] = useState(tagsApi)

	const [lastFilterList, setLastFilterList] = useState(sourceHelper.getFilter(sourceApi))
	const [currentConcept, setCurrentConcept] = useState([])
	// Filters Button
	const [filtersButton, setFiltersButton] = useState(highlightFilter)
	// LINE CHART CONFIG
	const [dataLineChart, setDataLineChart] = useState([])

	const [dateStart, setDateStart] = useState()
	const [dateInput, setDateInput] = useState()
	const [infoPage, setInfoPage] = useState(true)
	const [documentsList, setDocumentslist] = useState()

	const [sortModel, setSortModel] = useState([])

	// SORT SAVED AND SHARED CONCEPTS LIST
	const [sortConcepts, setSortConcepts] = useState({
		dateSaved: "",
		alphabeticalSaved: "desc",
		dateShared: "",
		alphabeticalShared: "desc",
	})

	const [selectedView, setSelectedView] = useState(1)
	const [viewItemsBtn, setViewItemsBtn] = useState("files")
	const [updateFileTypes, setUpdateFiletypes] = useState()
	const [fileTypesRefresh, setFileTypesRefresh] = useState(0)
	const [docCount, setDocCount] = useState(0)
	const [currentTag, setCurrentTag] = useState("")
	const [currentSort, setCurrentSort] = useState("")
	const [resetPage, setResetPage] = useState(false)
	const [tempSearchText, setTempSearchText] = useState(null)
	const [tempCategories, setTempCategories] = useState(null)

	const [selectedSearch, setSelectedSearch] = useState(null)

	//// SORT SAVED AND SHARED CONCEPTS LIST
	/****************Ragnar Lodbrok****************/

	const [activeTab, setActiveTab] = useState(location.search !== "" ? "none" : "all_documents")
	const [filterDate, setFilterDate] = useState()
	const [needToFilter, setNeedToFilter] = useState(false)
	const [savedTags, setSavedTags] = useState(tags)
	const [savedTagsExclude, setSavedTagsExclude] = useState(tagsExclude)
	const [tempInputSearch, setTempInputSearch] = useState(null)
	const [requestByFilters, setRequestByFilters] = useState(false)
	const [cancelRequestToken, setCancelRequestToken] = useState({ old: null, new: null })
	const [isAllDocsViewSelected, setAllDocsView] = useState(true)

	//pagination
	const [page, setPage] = useState(1)
	const [pageCount, setPageCount] = useState(10)
	const [recordsPerPage, setRecordsPerPage] = useState(10)
	const [toRetainFilters, setToRetainFilters] = useState(history?.location?.state?.reviewId ? false : true)
	const [selectedYourConceptsDropdown, setSelectedYourConceptsDropdown] = useState("")
	const [selectedSharedConceptsDropdown, setSelectedSharedConceptsDropdown] = useState("")
	const [selectedYourSearchDropdown, setSelectedYourSearchDropdown] = useState("")
	const [selectedSharedSearchDropdown, setSelectedSharedSearchDropdown] = useState("")
	const [selectedSearchName, setSelectedSearchName] = useState("")

	const prevRecordsPerPage = usePrevious(recordsPerPage)

	//delete search states
	const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)
	const [deletedId, setDeletedId] = useState(undefined)

	//review state
	const [openReviewForm, setOpenReviewForm] = useState(false)
	const [queryParams, setQueryParams] = useState({})
	const onLoadRef = useRef(true)

	/**graph drawer */
	const [openDrawer, setOpenDrawer] = useState(false)
	const [panel, setPanel] = useState("one")
	const initilaselectedDateRange = {
		initial: { start: "", end: "" },
		sliderPicker: { start: "", end: "" },
		graphPicker: { start: "", end: "" },
		selected: null,
	}
	const [selectedGraphDateRange, setSelectedGraphDateRange] = useState(initilaselectedDateRange)

	const handlePanelChange = (event, currentPanel) => {
		setPanel((prev) => currentPanel)
	}

	const toggleExpandGraph = () => {
		dispatch(setExpandGraph(!expandGraph))
		if (expandGraph) setOpenDrawer((prev) => false)

		//update the queryparams
		const queryParamsString = getQueryParams()
		const updatedQueryParams = { ...queryParamsString, expand_graph: !expandGraph }
		const queryString = buildQueryString(updatedQueryParams)
		const url = `${window.location.pathname}?${queryString}`
		history.push(url)
	}

	const [openExportEvent, setOpenExportEvent] = useState(false)
	const [openSaveDialog, setOpenSaveDialog] = useState(false)
	const refetchGraphRef = useRef(true)
	const dateRangeRef = useRef(initilaselectedDateRange)
	/* ******************* END REACT STATES ******************* */

	/* ******************* VARIABLES ******************* */
	let checker = (arr, target) => target.every((v) => arr.includes(v))
	const filtersObject = { ...filtersButton, ...filterList }
	/* ******************* END VARIABLES ******************* */

	const allDocumentsCallCount = useRef(0)

	/* ******************* USE-EFFECTS ******************* */

	useEffect(() => {
		if (
			history?.location?.state?.searchObject &&
			Object.keys(history?.location?.state?.searchObject)?.length > 0 &&
			searchesList?.length > 0
		) {
			setAllDocsView((prev) => false)
			const { searchObject } = history?.location?.state
			const selectedSearchType = searchObject?.shared === 0 ? "saved_search" : "shared_search"
			setActiveTab((prev) => selectedSearchType)
			handleYourSearchedChange(
				selectedSearchType,
				_.cloneDeep({
					...searchObject,
					params: { ...searchObject?.params, text: searchTermDeparse(searchObject?.params?.text) },
				}),
				true
			)
			window.history.replaceState({}, document?.title)
		}
	}, [searchesList, history?.location?.state?.searchObject])

	useEffect(() => {
		dispatch(updateViewDocumentsSavedTagsExclude(savedTagsExclude))
	}, [savedTagsExclude])

	useEffect(() => {
		dispatch(updateViewDocumentsSavedTags(savedTags))
	}, [savedTags])

	useEffect(() => {
		dispatch(updateViewDocumentsHighlight(filtersButton))
	}, [filtersButton])

	// useEffect(() => {
	// 	//Render on init
	// 	if (!tagsApi.tags.length) dispatch(requestCustomTags())
	// 	dispatch(requestSavedBuildConcepts())
	// 	dispatch(requestSources())
	// 	dispatch(saveInitSearchSagas())
	// 	// eslint-disable-next-line

	// 	/****************Ragnar Lodbrok****************/
	// }, [])

	useEffect(() => {
		if (
			!(history?.location?.state?.searchObject && Object.keys(history?.location?.state?.searchObject)?.length > 0) ||
			!history?.location?.state?.reviewId
		)
			clearAll(toRetainFilters && history?.location?.pathname?.split("/")?.[2] ? "none" : "all_documents")
		dispatch(requestSavedBuildConcepts())
		dispatch(saveInitSearchSagas())
		setAllDocsView(true)
		dispatch(getEventsRequest())
		/****************Ragnar Lodbrok****************/
	}, [selectedBaseId])

	useEffect(() => {
		// if (Object.keys(sourceApi).length === 0 && Object.keys(lastFilterList).length === 0) {
		// 	dispatch(requestSources())
		// 	dispatch(requestCustomTags())
		// }

		if (Object.keys(sourceApi).length > 0) {
			const sources = sourceHelper.getFilter(sourceApi)
			setFilterList(sources)
			setLastFilterList(sources)
		}
	}, [sourceApi])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		//Removed the review_id check as part of ticket https://anzyz.atlassian.net/browse/LD-2832
		if (history?.location?.state?.searchObject && Object.keys(history?.location?.state?.searchObject)?.length > 0) return
		const payload = getAllDocumentPayload(true)
		dispatch(
			getAllDocumentsRequest({
				params: payload,
				jobIdToRetainData: null,
			})
		)
	}, [selectedBaseId])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		debouncedCallback()
	}, [page])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		isApplyTagSuccess && debouncedCallback()
	}, [isApplyTagSuccess])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		isTaggedDateUpdated && debouncedCallback()
	}, [isTaggedDateUpdated])

	useEffect(() => {
		if (toRetainFilters || history?.location?.state?.reviewId) {
			return
		}
		debouncedCallback()
	}, [showDuplicate])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		setPage(1)
		debouncedCallback()
	}, [recordsPerPage])

	const fetchData = () => {
		getDocsFromAPI()
	}

	const ref = useRef(fetchData)

	useEffect(() => {
		ref.current = fetchData
	}, [
		page,
		sortModel,
		recordsPerPage,
		currentConcept,
		selectedSharedConceptsDropdown,
		selectedSharedConceptsDropdown,
		selectedYourConceptsDropdown,
		selectedYourSearchDropdown,
		tempInputSearch,
		selectedView,
		selectedReview,
		isAllDocsViewSelected,
		showDuplicate,
		subjectFilterData,
	])

	const debouncedCallback = useMemo(() => {
		const func = () => {
			ref?.current?.()
		}
		return _.debounce(func, 500)
	}, [])

	const {
		filtersDom,
		filters,
		isEmailFilter,
		handleReset,
		setFilters,
		fromHandler,
		toHandler,
		dateRangeHandler,
		fileTypesHandler,
		tagsHandler,
		commentsByHandler,
		viewHandler,
		setIsEmailFilter,
		setResetFilter,
		initialFilters,
		subjectSearchHandler,
		attachmentHandler,
		handleDateRangeChange,
	} = useFilters({
		setPage,
		ref,
		fetchData,
		debouncedCallback,
		sortModel,
		setSortModel,
		toRetainFilters,
	})

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		if (
			(history?.location?.state?.searchObject && Object.keys(history?.location?.state?.searchObject)?.length > 0) ||
			history?.location?.state?.reviewId
		)
			return
		/// when user directly clicks on your or shared concepts
		// if (
		// 	((activeTab === "shared_concepts" && !selectedYourConceptsDropdown) ||
		// 		(activeTab === "your_concepts" && !selectedSharedConceptsDropdown)) &&
		// 	!selectedYourSearchDropdown &&
		// 	!selectedSharedSearchDropdown
		// ) {
		// 	// do nothing
		// }

		// /// when user has already clicked on your concept and again clicking on shared concept or viceversa
		// if (
		// 	(activeTab === "shared_concepts" && selectedYourConceptsDropdown?.length > 0) ||
		// 	(activeTab === "your_concepts" && selectedSharedConceptsDropdown?.length > 0)
		// 	//&&
		// 	// !selectedYourSearchDropdown &&
		// 	// !selectedSharedSearchDropdown
		// ) {
		// 	// do nothing
		// }

		// /// when user is directly clicking on your search or shared search
		// if (
		// 	((activeTab === "saved_search" && !selectedSharedSearchDropdown) ||
		// 		(activeTab === "shared_search" && !selectedYourSearchDropdown)) &&
		// 	!selectedYourConceptsDropdown &&
		// 	!selectedSharedConceptsDropdown
		// ) {
		// 	// do nothing
		// }

		// /// when user has already clicked on your search and then he's clicking on your shared search or viceversa
		// if (
		// 	((activeTab === "saved_search" && selectedSharedSearchDropdown) ||
		// 		(activeTab === "shared_search" && selectedYourSearchDropdown)) &&
		// 	!selectedYourConceptsDropdown &&
		// 	!selectedSharedConceptsDropdown
		// ) {
		// 	if (activeTab === "saved_search") {
		// 		setSelectedSharedSearchDropdown((prevData) => "")
		// 	} else {
		// 		setSelectedYourSearchDropdown((prevData) => "")
		// 	}
		// }

		// /// when user clicks on concept then on search
		// if (
		// 	(activeTab === "saved_search" && (selectedYourConceptsDropdown?.length > 0 || selectedSharedConceptsDropdown?.length > 0)) ||
		// 	(activeTab === "shared_search" && (selectedYourConceptsDropdown?.length > 0 || selectedSharedConceptsDropdown?.length > 0))
		// ) {
		// 	if (activeTab === "saved_search") {
		// 		setSelectedSharedSearchDropdown((prevData) => "")
		// 	} else {
		// 		setSelectedYourSearchDropdown((prevData) => "")
		// 	}
		// 	setSelectedSharedConceptsDropdown((prevData) => "")
		// 	setSelectedYourConceptsDropdown((prevData) => "")
		// }

		// /// when user clicks on search then on concepts
		// if (
		// 	(activeTab === "shared_concepts" && (selectedYourSearchDropdown || selectedSharedSearchDropdown)) ||
		// 	(activeTab === "your_concepts" && selectedYourSearchDropdown && selectedSharedSearchDropdown)
		// ) {
		// 	// do nothing
		// }

		///////////////////////////
		if (activeTab === "all_documents") {
			setSortModel((prevSort) => [])
			handleReset()
		}
	}, [activeTab])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		debouncedCallback()
	}, [sortModel])

	useEffect(() => {
		if (isSearchDeleted && searchDeletedId === selectedSearch?.id) {
			clearAllButtonClick() //clear the UI
			dispatch(deleteSearchReset()) //reset the redux state
			setOpenDeleteConfirm((prev) => false) //hide confirm popup
			setDeletedId((prev) => undefined) //reset state
		} else if (isSearchDeleted && searchDeletedId) {
			setOpenDeleteConfirm((prev) => false)
			dispatch(deleteSearchReset())
			setDeletedId((prev) => undefined)
		}
	}, [isSearchDeleted, searchDeletedId])

	const getSkipCount = () => {
		return page === 1 ? 0 : (page - 1) * recordsPerPage
	}

	const getUpdatedFilter = () => {
		let filterWithGraphDate = { ...filters }
		if (
			dateRangeRef.current.selected === GRAPH_DATE_OPTIONS.GRAPH_PICKER ||
			dateRangeRef.current.selected === GRAPH_DATE_OPTIONS.SLIDER
		) {
			filterWithGraphDate = {
				...filters,
				tagged_date: {
					...filters.tagged_date,
					data:
						dateRangeRef.current.selected === GRAPH_DATE_OPTIONS.SLIDER
							? [
									moment(dateRangeRef.current[GRAPH_DATE_OPTIONS.SLIDER]?.start).format(PAYLOAD_DATE_FORMAT),
									moment(dateRangeRef.current[GRAPH_DATE_OPTIONS.SLIDER]?.end).format(PAYLOAD_DATE_FORMAT),
							  ]
							: [
									moment(dateRangeRef.current[GRAPH_DATE_OPTIONS.GRAPH_PICKER]?.start).format(PAYLOAD_DATE_FORMAT),
									moment(dateRangeRef.current[GRAPH_DATE_OPTIONS.GRAPH_PICKER]?.end).format(PAYLOAD_DATE_FORMAT),
							  ],
				},
			}
		}

		return filterWithGraphDate
	}

	const getAllDocumentPayload = () => {
		const skipCount = getSkipCount()
		const updatedFilter = getUpdatedFilter()
		const filtersPayload = parsePayload(updatedFilter)
		const searchTerms = tempInputSearch && tempInputSearch?.length > 0 ? searchTermParse(tempInputSearch) : []
		const params = history?.location?.pathname?.split("/")
		const payload = {
			text: searchTerms,
			categories: [],
			neg_text: "",
			return_count: recordsPerPage,
			skip_count: skipCount,
			suppress_content: false,
			treat_like_concept: false,
			remove_duplicates: showDuplicate,
			mode: "FILE",
			expand_graph: expandGraph,
			...filtersPayload,
			additional_params: {
				page_context: params?.[1],
			},
		}

		if (subjectFilterData) {
			payload["subject"] = subjectFilterData
		}

		if (!!sortModel.length) {
			const sort = { field: sortModel[0].field, ordering: sortModel[0].sort === "asc" ? 1 : -1 }
			payload["sort"] = sort
		}

		if (Object.keys(selectedReview)?.length > 0) {
			payload["additional_params"] = {
				...payload?.additional_params,
				review_id: selectedReview?.id,
				is_case_admin: is_case_admin,
			}
		}

		const grpahDate = _.clone(dateRangeRef.current)
		if (grpahDate.selected) {
			payload["grpahDate"] = grpahDate
		}

		dateRangeRef.current = initilaselectedDateRange

		return payload
	}

	//Getting Documents from API
	const getDocsFromAPI = () => {
		//Validar y comprobar si nom hay errores
		//Hide alert
		// dispatch(hideAlertAction())
		const params = history?.location?.pathname?.split("/")
		if (selectedView === 1) {
			if (isAllDocsViewSelected) {
				const payload = getAllDocumentPayload()
				dispatch(
					getAllDocumentsRequest({
						params: payload,
						jobIdToRetainData: toRetainFilters ? history?.location?.pathname?.split("/")?.[2] : null,
						triggerPSearch:
							localStorage.getItem(LOCAL_STORAGE_KEYS.TRIGGER_P_SEARCH) &&
							JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.TRIGGER_P_SEARCH)),
					})
				)
				if (refetchGraphRef.current) {
					dispatch(getGraphDataRequest(payload))
				} else {
					refetchGraphRef.current = true
				}

				localStorage.setItem(LOCAL_STORAGE_KEYS.TRIGGER_P_SEARCH, false)
				setToRetainFilters(false)
				setResetFilter((prev) => false)
				dispatch(setCurrentSearchAction(tempInputSearch, currentConcept, "search", parsePayload(filters)))
			} else {
				const updatedFilter = getUpdatedFilter()

				let payload = {
					filters: parsePayload(updatedFilter),
					recordsPerPage: recordsPerPage,
					skipCount: getSkipCount(),
					sortModel: sortModel,
					additional_params: {
						page_context: params?.[1],
					},
					showDuplicate: showDuplicate,
					expand_graph: expandGraph,
				}

				if (subjectFilterData) {
					payload["subject"] = subjectFilterData
				}

				if (tempInputSearch) {
					payload["inputSearch"] = tempInputSearch
				}
				if (currentConcept?.length > 0) {
					payload["concept_id_list"] = [...currentConcept]
				}
				if (selectedYourSearchDropdown) {
					payload["your_search_id"] = selectedYourSearchDropdown
				}

				if (selectedSharedSearchDropdown) {
					payload["shared_search_id"] = selectedSharedSearchDropdown
				}

				if (selectedYourSearchDropdown || selectedSharedSearchDropdown) {
					payload["additional_params"] = {
						...payload?.additional_params,
						searchId: selectedSharedSearchDropdown || selectedYourSearchDropdown || undefined,
						searchName: selectedSearch?.name || undefined,
					}
				}

				if (Object.keys(selectedReview)?.length > 0) {
					payload["additional_params"] = {
						...payload?.additional_params,
						...selectedReview?.search_params?.additional_params,
						review_id: selectedReview?.id,
						is_case_admin: is_case_admin,
					}

					//if in Edit review update button is triggered then will update the isUpdateTrigger status here
					// if (isUpdateTrigger) {
					// 	dispatch(isReviewUpdateTrigger(false))
					// }
				}

				// added search id to additional param
				if (selectedSearch?.id) {
					payload["additional_params"] = {
						...payload?.additional_params,
						search_id: selectedSearch?.id,
					}
				}

				const grpahDate = _.clone(dateRangeRef.current)
				if (grpahDate.selected) {
					payload["grpahDate"] = grpahDate
				}

				dateRangeRef.current = initilaselectedDateRange

				dispatch(
					loadSearchFromAPI({
						params: payload,
						jobIdToRetainData: toRetainFilters ? history?.location?.pathname?.split("/")?.[2] : null,
					})
				)

				if (refetchGraphRef.current) {
					const graphPayload = getGraphPayload(payload)
					dispatch(getGraphDataRequest(graphPayload))
				} else {
					refetchGraphRef.current = true
				}
				setToRetainFilters(false)
				setResetFilter((prev) => false)
				dispatch(setCurrentSearchAction(tempInputSearch, currentConcept, "search", parsePayload(filters)))
			}
		} else {
			dispatch(setCurrentSearchAction(tempInputSearch, currentConcept, "search", parsePayload(filters)))
			setResetFilter((prev) => false)
		}
	}

	useEffect(() => {
		dispatch(getRetainFiltersSuccess())
		if (
			(history?.location?.state?.searchObject && Object.keys(history?.location?.state?.searchObject)?.length > 0) ||
			history?.location?.state?.reviewId
		) {
			return
		}

		const queryString = getQueryParams()
		if (!_.isEmpty(queryString)) {
			setQueryParams((prev) => queryString)
		} else {
			setToRetainFilters((prevState) => false)
			const payload = getAllDocumentPayload(true)

			dispatch(
				getAllDocumentsRequest({
					params: payload,
					jobIdToRetainData: null,
				})
			)
			if (refetchGraphRef.current) {
				dispatch(getGraphDataRequest(payload))
			} else {
				refetchGraphRef.current = true
			}
		}

		/*if (history?.location?.pathname?.split("/")?.[2]) {
			dispatch(getRetainFiltersList(history?.location?.pathname?.split("/")?.[2]))
		} else {
			setToRetainFilters((prevState) => false)
			const payload = getAllDocumentPayload(true)
			dispatch(
				getAllDocumentsRequest({
					params: payload,
					jobIdToRetainData: null,
				})
			)
		}*/

		dispatch(resetPageViewerData())
		return () => {
			dispatch(getRetainFiltersSuccess())
			dispatch(reSetReview())
		}
	}, [])

	useEffect(() => {
		if (!toRetainFilters) {
			dispatch(getRetainFiltersSuccess())
		}
	}, [toRetainFilters])

	useEffect(() => {
		if (isSearchSaved) {
			debouncedCallback() //p_search call
			dispatch(saveNewSearchFailedClear()) //reset the isSearchSaved flag
		}
	}, [isSearchSaved])

	//reload the list once delete is success then update the flag
	useEffect(() => {
		if (shouldReloadList) {
			dispatch(reloadList(false))
			debouncedCallback()
		}
	}, [shouldReloadList])

	//unmount the component
	useEffect(() => {
		return () => {
			dispatch(getRetainFiltersSuccess())
			dispatch(reSetReview())
		}
	}, [])

	const savedSearchesList = useMemo(
		() => (searchesList.length > 0 ? searchesList?.filter((item) => item?.shared === 0) : []),
		[searchesList]
	)

	const sharedSearchesList = useMemo(
		() => (searchesList.length > 0 ? searchesList?.filter((item) => item?.shared === 1) : []),
		[searchesList]
	)

	useEffect(() => {
		if (reviewList?.length && queryParams?.additional_params?.review_id && !selectedReview?.id && !isAllDocsViewSelected) {
			/**
			 * Have a review list
			 * Have the review_id in the query string url
			 * But in selectedreview if we dont have that review
			 * then we need to set the review as selected
			 * Here we removed getReviewRequest API dependency
			 */
			const id = queryParams?.additional_params?.review_id
			const isCaseAdmin = queryParams?.additional_params?.is_case_admin || false
			const review = reviewList?.find((review) => review?.id === id)
			if (review) {
				dispatch(setIsCaseAdmin(isCaseAdmin))
				dispatch(setReview(review))
			}
		}
	}, [reviewList])

	const mapDataToState = (data) => {
		mapFiltersToState(data)
		if (data?.additional_params?.review_id) {
			//dispatch(getReviewRequest({ id: data?.additional_params?.review_id, is_case_admin: data?.additional_params?.is_case_admin }))
			setAllDocsView((prev) => false)
			setActiveTab((prev) => "none")
		}
		if (data?.sort) setSortModel((prevData) => [{ ...data?.sort, sort: data?.sort?.ordering === 1 ? "asc" : "desc" }])
		const searchText = searchTermDeparse(data?.text)
		setTempInputSearch((prevData) => searchText)
		if (data?.categories?.length > 0) {
			setCurrentConcept((prevData) => [...data?.categories])
			setAllDocsView((prevData) => false)
			const sharedItems = sharedConcepts?.reduce((result, currItem) => {
				if (data?.categories.includes(currItem?.id)) {
					result.push(currItem?.id)
				}
				return result
			}, [])
			if (sharedItems?.length > 0) {
				setSelectedSharedConceptsDropdown((prevData) => [...sharedItems])
				setActiveTab((prevData) => "shared_concepts")
			}
			const savedItems = savedConcepts?.reduce((result, currItem) => {
				if (data?.categories.includes(currItem?.id)) {
					result.push(currItem?.id)
				}
				return result
			}, [])
			if (savedItems?.length > 0) {
				setSelectedYourConceptsDropdown((prevData) => [...savedItems])
				setActiveTab((prevData) => "your_concepts")
			}
		}

		if (_.has(data, "remove_duplicates")) {
			dispatch(showDuplicateAction({ data: data?.remove_duplicates }))
		}

		if (data?.your_search_id?.length > 0) {
			setAllDocsView((prevData) => false)
			const item = savedSearchesList?.find((item) => item?.id === data?.your_search_id)
			if (item) {
				setSelectedSearch((prev) => _.cloneDeep(item))
				setSelectedSearchName((prevData) => item?.name)
				setSelectedYourSearchDropdown((prevData) => item?.id)
				setActiveTab((prevData) => "saved_search")
			}
		} else if (data?.shared_search_id?.length > 0) {
			setAllDocsView((prevData) => false)
			const item = sharedSearchesList?.find((item) => item?.id === data?.shared_search_id)
			if (item) {
				setSelectedSearch((prev) => _.cloneDeep(item))
				setSelectedSearchName((prevData) => item?.name)
				setSelectedSharedSearchDropdown((prevData) => item?.id)
				setActiveTab((prevData) => "shared_search")
			}
		}

		if (data?.categories?.length <= 0 && data?.text?.length <= 0 && !data?.additional_params?.review_id) {
			setActiveTab((prevData) => "all_documents")
			setAllDocsView((prevData) => true)
		}

		if (data?.expand_graph) {
			dispatch(setExpandGraph(true))
		}

		setRecordsPerPage((prevData) => data?.return_count)
		setPage((prevData) => (data?.skip_count === 0 ? 1 : data?.skip_count / data?.return_count + 1))
		if (!data?.additional_params?.review_id) {
			debouncedCallback()
		}
	}

	useEffect(() => {
		if (
			!_.isEmpty(queryParams) &&
			onLoadRef.current === true &&
			((!queryParams?.your_search_id && !queryParams?.shared_search_id) ||
				(savedSearchesList?.length > 0 && queryParams?.your_search_id) ||
				(sharedSearchesList?.length > 0 && queryParams?.shared_search_id)) &&
			(queryParams?.categories?.length <= 0 ||
				(savedConcepts?.length > 0 && queryParams?.categories?.length > 0) ||
				(sharedConcepts?.length > 0 && queryParams?.categories?.length > 0))
		) {
			onLoadRef.current = false
			mapDataToState(queryParams)
		} else if (retainedJobFailed) {
			clearAllButtonClick()
		}
	}, [savedSearchesList, sharedSearchesList, savedConcepts, sharedConcepts])

	const regenerateData = () => {
		const chartData = []
		for (let i = 0; i < 20; i++) {
			const value = Math.floor(Math.random() * i + 3)
			chartData.push({
				label: i,
				value,
				tooltipContent: { startDate: i, endDate: value },
			})
		}
		setDataLineChart(chartData)
	}

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		setPage((prevData) => 1)
		debouncedCallback()
	}, [subjectFilterData])

	const regenerateData_test = () => {
		const chartData_test = [
			{
				label: "Feb",
				value: 10,
				//tooltipContent: {startDate: 'Jan', endDate: 10}
			},
			{
				label: "March",
				value: 20,
				//tooltipContent: {startDate: 1, endDate: 20}
			},
			{
				label: "April",
				value: 30,
				//tooltipContent: {startDate: 2, endDate: 30}
			},
			{
				label: "May",
				value: 20,
				//tooltipContent: {startDate: 3, endDate: 20}
			},
		]

		setDataLineChart(chartData_test)
	}

	try {
		document.body.style.backgroundImage = "none"
		document.body.classList.remove("newLoginPage")
	} catch (e) {}

	/****************Ragnar Lodbrok****************/

	const handleAllDocumentsClick = (isAllDocsViewClicked) => {
		if (selectedReview?.id || isReviewFormOpen) {
			//if we are in context of review remove review context
			dispatch(reSetReview())
		}
		clearAll()
		setAllDocsView(isAllDocsViewClicked)
	}

	useEffect(() => {
		if (!isUpdateTrigger) {
			if (toRetainFilters && !_.isEmpty(queryParams) && Object.keys(selectedReview)?.length > 0) {
				debouncedCallback()
				return
			}
			if (Object.keys(selectedReview)?.length > 0 && !history?.location?.state?.reviewId) {
				clearAll("none", false)
			}
			if (history?.location?.state?.reviewId && Object.keys(selectedReview)?.length > 0) {
				clearAll("none", false)
				window.history.replaceState({}, document?.title)
			}
		}
	}, [selectedReview])

	const handleYourConceptsChange = (toolbarType, item) => {
		if (toolbarType === "your_concepts") {
			setCurrentConcept((prevData) => [
				...(selectedSharedConceptsDropdown?.length > 0 ? selectedSharedConceptsDropdown : []),
				...(item && item?.length > 0 ? item : []),
			])
		} else {
			setCurrentConcept((prevData) => [
				...(selectedYourConceptsDropdown?.length > 0 ? selectedYourConceptsDropdown : []),
				...(item && item?.length > 0 ? item : []),
			])
		}
	}

	const handleYourSearchedChange = (toolbarType, item, isCalledFromDashboard = false) => {
		setAllDocsView(false)
		if (toolbarType === "saved_search") {
			setSelectedSharedSearchDropdown((prevData) => "")
			if (isCalledFromDashboard) setSelectedYourSearchDropdown((prevData) => item?.id)
		} else {
			if (isCalledFromDashboard) setSelectedSharedSearchDropdown((prevData) => item?.id)
			setSelectedYourSearchDropdown((prevdata) => "")
		}
		const categoriesArrayIds = item?.params?.categories?.map((concept) => concept?.id)
		const savedConceptsArray = savedConcepts?.reduce(
			(allConcepts, currConcept) =>
				categoriesArrayIds.includes(currConcept?.id) ? [...allConcepts, currConcept?.id] : [...allConcepts],
			[]
		)
		const sharedConceptsArray = sharedConcepts?.reduce(
			(allConcepts, currConcept) =>
				categoriesArrayIds.includes(currConcept?.id) ? [...allConcepts, currConcept?.id] : [...allConcepts],
			[]
		)
		if (savedConceptsArray?.length > 0) {
			setSelectedYourConceptsDropdown((prevData) => [...savedConceptsArray])
		} else {
			setSelectedYourConceptsDropdown((prevData) => "")
		}
		if (sharedConceptsArray?.length > 0) {
			setSelectedSharedConceptsDropdown((prevData) => [...sharedConceptsArray])
		} else {
			setSelectedSharedConceptsDropdown((prevData) => "")
		}
		setTempInputSearch((prevData) => item?.params?.text)
		setCurrentConcept((prevData) => [...savedConceptsArray, ...sharedConceptsArray])
		//setSelectedSearchName(item.name)
		setSelectedSearch(item)
		mapFiltersToState(item?.params?.filters)
		if (isCalledFromDashboard) debouncedCallback()
	}

	const mapFiltersToState = (data) => {
		const filterKeysAndMethods = {
			from: () => {
				fromHandler(data?.from?.data || [])
			},
			to: () => {
				toHandler(data?.to?.data || [])
			},
			tagged_date: () => {
				dateRangeHandler({
					startDate: data?.tagged_date?.data?.[0] ? moment(data?.tagged_date?.data?.[0]) : "",
					endDate: data?.tagged_date?.data?.[1] ? moment(data?.tagged_date?.data?.[1]) : "",
				})
			},
			source: () => {
				fileTypesHandler(data?.source?.data || [])
				setIsEmailFilter((prevData) => data?.source?.data?.[0] === "email" && data?.source?.data?.length === 1)
			},
			tags: () => {
				tagsHandler(data?.tags?.data || [])
			},
			commentator: () => {
				const names = users?.reduce((allUsers, currUser) => {
					if (data?.commentator?.data?.includes(currUser?.user_id)) {
						const tempUsers = [...allUsers, currUser?.username]
						return tempUsers
					}
					return allUsers
				}, [])
				commentsByHandler(names || [])
			},
			view_count: () => {
				viewHandler(data?.view_count?.kind)
			},
			subject: () => {
				subjectSearchHandler(data?.subject)
			},
			has_attachment: () => {
				attachmentHandler(data?.has_attachment)
			},
		}
		//Todo: how to load previous data in graph
		// if (data?.grpahDate?.selected === GRAPH_DATE_OPTIONS.GRAPH_PICKER || data?.grpahDate?.selected === GRAPH_DATE_OPTIONS.SLIDER) {
		// 	delete filterKeysAndMethods["tagged_date"]
		// 	setSelectedGraphDateRange(data?.grpahDate?.selected)
		// 	//refetchGraphRef.current = false
		// }

		const filterData = {}
		const cloneFilter = _.cloneDeep(initialFilters)
		for (let filterKey of Object.keys(filterKeysAndMethods)) {
			if (data?.[filterKey]) {
				filterData[filterKey] = data?.[filterKey]
			} else {
				filterData[filterKey] = cloneFilter[filterKey]
			}
			filterKeysAndMethods?.[filterKey]?.()
		}

		setFilters((prevData) => ({ ...prevData, ...filterData }))
	}

	const handleSearchCall = () => {
		setAllDocsView((prevData) => false)
		if (!tempInputSearch && tempInputSearch?.length <= 0 && currentConcept?.length <= 0) {
			dispatch(
				setNotification({
					data: t("genericMsgs.noTextAndConceptSelected"),
					severity: "error",
				})
			)
			return
		}
		//handleReset()
		//fetchData()
		//on search button click will not clear filter
		setPage((prevData) => 1)
		debouncedCallback()
	}

	const clearAll = (activeTabType = "all_documents", isAllDocsView = true) => {
		dispatch(resetSelectedIdsAction())
		setSelectedYourConceptsDropdown((prevData) => "")
		setSelectedSharedConceptsDropdown((prevData) => "")
		setSelectedYourSearchDropdown((prevData) => "")
		setSelectedSharedSearchDropdown((prevData) => "")
		setCurrentConcept((prev) => [])
		//setSelectedSearchName((prevData) => "")
		setTempInputSearch((prevData) => "")
		//setTempInputConcept((prevData) => "")
		if (selectedReview?.id) {
			setActiveTab((prevData) => "none")
		} else {
			setActiveTab((prevData) => activeTabType)
		}
		setAllDocsView((prevData) => isAllDocsView)

		setSelectedSearch((prev) => null)
		dispatch(setSelectedSearchAction(undefined))
		handleReset()
		dispatch(setCurrentSearchAction("", [], "search", {})) //dispatch the default values to search on clear button click
	}

	const clearAllButtonClick = () => {
		clearAll()
		debouncedCallback()
	}

	const applyFilterSource = () => {
		// if (tempSearchText !== null || tempCategories !== null){
		setRequestByFilters(true)
		// }
	}

	const deleteSavedSearch = (event, savedSearchId) => {
		event.stopPropagation()
		setOpenDeleteConfirm((prev) => true)
		setDeletedId((prev) => savedSearchId)
	}

	const deleteSearchConfirm = () => {
		if (deletedId) {
			dispatch(deleteSearchLoad(deletedId))
		}
	}

	const deleteSearchConfirmDismiss = () => {
		setOpenDeleteConfirm((prev) => false)
		setDeletedId((prev) => undefined)
	}

	useEffect(() => {
		//active filters in search
		let activeInSearch = []

		Object.keys(currentSearchFilter).forEach(function (key) {
			if (currentSearchFilter[key] === true) {
				activeInSearch.push(key)
			}
		})

		let activeInFilter = []
		Object.keys(filterList).forEach(function (key) {
			if (filterList[key] === true) {
				activeInFilter.push(key)
			}
		})

		if (tempSearchText !== null || tempCategories !== null) {
			setRequestByFilters(true)
		}
	}, [requestNewDateSearch, filtersButton.fromDate, filtersButton.toDate])

	useEffect(() => {
		if (requestByFilters) {
			setRequestByFilters(false)
		}
		return () => {
			if (cancelRequestToken.old !== null) {
				cancelRequestToken.old.cancel("axios request cancelled")
			}
		}
	}, [requestByFilters])

	const handleSaveSearch = (data, isSaveAs) => {
		if (isSaveAs) {
			//check search is exist or not
			const isExist = searchesList.some((item) => item.name === data.name)
			if (isExist)
				return dispatch(
					setNotification({
						data: t("genericMsgs.saveSearchErrorMessage"),
						severity: "error",
					})
				)
		}

		const params = {
			text: tempInputSearch,
			categories: currentConcept,
			return_count: 0,
			skip_count: 0,
			suppress_content: false,
			filters: parsePayload(filters),
		}
		const docs_count = isAllDocsViewSelected ? allDocumentsList?.count || 0 : conceptsDocCount || 0
		const payload = { ...data, params, docs_count, id: isSaveAs ? undefined : selectedSearch?.id }
		dispatch(saveNewSearch(payload))
	}

	//on review edit button click
	const handleEditReview = (id) => {
		if (id === selectedReview?.id) {
			setOpenReviewForm(true)
			dispatch(setReviewFormOpen(true))
		}
	}

	useEffect(() => {
		dispatch(showDuplicateActionReset())
	}, [])

	useEffect(() => {
		dispatch(updateTaggedDateReset())
	}, [isTaggedDateUpdated])

	useEffect(() => {
		window.addEventListener("beforeunload", removeFileIdFromLocalStorage)

		return () => {
			window.removeEventListener("beforeunload", removeFileIdFromLocalStorage)
			removeFileIdFromLocalStorage()
		}
	}, [])

	const updateGraphDateRange = (date) => {
		const updatedDate =
			date.selected === GRAPH_DATE_OPTIONS.SLIDER
				? {
						...selectedGraphDateRange,
						selected: date.selected,
						sliderPicker: date[GRAPH_DATE_OPTIONS.SLIDER],
				  }
				: { ...selectedGraphDateRange, selected: date.selected, graphPicker: date[GRAPH_DATE_OPTIONS.GRAPH_PICKER] }
		setSelectedGraphDateRange((prev) => updatedDate)
		// setGraphTagedDate(
		// 	date.selected === GRAPH_DATE_OPTIONS.SLIDER ? date[GRAPH_DATE_OPTIONS.SLIDER] : date[GRAPH_DATE_OPTIONS.GRAPH_PICKER]
		// )
	}

	const DEBOUNCE_TIME = 2000
	const debounceGraphDateRange = _.debounce(updateGraphDateRange, DEBOUNCE_TIME)

	const refetchList = useCallback((date) => {
		refetchGraphRef.current = false
		debounceGraphDateRange(date)
	}, [])

	useEffect(() => {
		dateRangeRef.current = selectedGraphDateRange
		debouncedCallback()
	}, [selectedGraphDateRange])

	const handleOpenSaveEventDialog = (reLoadList = false) => {
		if (reLoadList) {
			//if status true -> event successfuly saved -> refresh the events list
			dispatch(getEventsRequest())
		}
		handleEventForm(false)
	}

	const handleEventForm = (isOpen) => {
		dispatch(setEventFormOpen(isOpen))
	}

	return (
		<Grid className={classes.root} container direction="row" data-testid="view_documents_page">
			<Grid item xs={12} className={classes.notification}>
				<Notification />
			</Grid>
			<Grid container alignItems="center" justifyContent="space-around">
				<Grid item>
					<Grid container alignItems="center">
						<Grid container alignContent="center" justifyContent="space-between">
							<Grid className={classes.allDocWrapper}>
								<AllDocuments activeTab={activeTab} onClickHandler={handleAllDocumentsClick} />
								<ConceptDropdown
									label={t("filterConceptDropdown.your_concepts")}
									handleListChange={handleYourConceptsChange}
									datalist={savedConcepts}
									isLoading={conceptsLoading}
									setSortConcepts={setSortConcepts}
									toolbarType={"your_concepts"}
									activeTab={activeTab}
									setActiveTab={setActiveTab}
									selected={selectedYourConceptsDropdown}
									setSelected={setSelectedYourConceptsDropdown}
									disabled={isReviewFormOpen}
								/>
								<ConceptDropdown
									label={t("filterConceptDropdown.shared_concepts")}
									handleListChange={handleYourConceptsChange}
									datalist={sharedConcepts}
									isLoading={conceptsLoading}
									boxStyle={{ maxWidth: 180, minWidth: 180 }}
									setSortConcepts={setSortConcepts}
									toolbarType={"shared_concepts"}
									activeTab={activeTab}
									setActiveTab={setActiveTab}
									selected={selectedSharedConceptsDropdown}
									setSelected={setSelectedSharedConceptsDropdown}
									disabled={isReviewFormOpen}
								/>
								<ToolbarDropdown
									label={t("filterConceptDropdown.your_search")}
									handleListChange={handleYourSearchedChange}
									datalist={savedSearchesList}
									isLoading={searchesLoading || conceptsLoading}
									boxStyle={{ maxWidth: 140, minWidth: 140 }}
									setSortConcepts={setSortConcepts}
									toolbarType={"saved_search"}
									nameField={"name"}
									countField={"docs_count"}
									activeTab={activeTab}
									setActiveTab={setActiveTab}
									selected={selectedYourSearchDropdown}
									setSelected={setSelectedYourSearchDropdown}
									deleteSavedSearch={deleteSavedSearch}
									isDeleteOption={true}
									disabled={isReviewFormOpen}
								/>
								<ToolbarDropdown
									label={t("filterConceptDropdown.shared_search")}
									handleListChange={handleYourSearchedChange}
									datalist={sharedSearchesList}
									isLoading={searchesLoading || conceptsLoading}
									setSortConcepts={setSortConcepts}
									toolbarType={"shared_search"}
									nameField={"name"}
									countField={"docs_count"}
									activeTab={activeTab}
									setActiveTab={setActiveTab}
									selected={selectedSharedSearchDropdown}
									setSelected={setSelectedSharedSearchDropdown}
									deleteSavedSearch={deleteSavedSearch}
									isDeleteOption={false}
									disabled={isReviewFormOpen}
								/>
							</Grid>
							<Grid className={classes.reviewWrapper}>
								<ReviewDropdown
									selectedSearch={selectedSearch}
									filesCount={isAllDocsViewSelected ? allDocumentsList?.count || 0 : conceptsDocCount || 0}
									open={openReviewForm}
									setOpen={setOpenReviewForm}
									loadSavedSearch={handleYourSearchedChange}
									clearSearchSection={clearAll}
									mapDataToState={mapDataToState}
								/>
							</Grid>
						</Grid>
						<Grid container>
							<SearchSection
								selectedSearch={selectedSearch}
								tempInputSearch={tempInputSearch}
								selectedYourConceptsDropdown={selectedYourConceptsDropdown}
								selectedSharedConceptsDropdown={selectedSharedConceptsDropdown}
								setTempInputSearch={setTempInputSearch}
								handleSearchCall={handleSearchCall}
								clearAllButtonClick={clearAllButtonClick}
								handleSaveSearch={handleSaveSearch}
								setSelectedSharedConceptsDropdown={setSelectedSharedConceptsDropdown}
								setSelectedYourConceptsDropdown={setSelectedYourConceptsDropdown}
								setCurrentConcept={setCurrentConcept}
								setSelectedSearch={setSelectedSearch}
								setSelectedYourSearchDropdown={setSelectedYourSearchDropdown}
								setSelectedSharedSearchDropdown={setSelectedSharedSearchDropdown}
								selectedYourSearchDropdown={selectedYourSearchDropdown}
								selectedSharedSearchDropdown={selectedSharedSearchDropdown}
								handleEditReview={handleEditReview}
							/>
						</Grid>
						{/* ////////////////// Filters ////////////////// */}
						<div className={classes.view}>{selectedView === 1 && filtersDom}</div>

						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Paper className={classes.graphWrapper} elevation={0}>
									<div style={{ position: "relative" }}>
										<div
											style={{
												position: "relative",
											}}
										>
											<TimelineChart
												refetchList={refetchList}
												navigator={true}
												showGraph={expandGraph ? true : false}
											/>
											{!expandGraph && <div onClick={toggleExpandGraph} className={classes.graphOverlay}></div>}
											{expandGraph && graphData?.length > 0 && (
												<>
													<Button
														size="small"
														onClick={() => setOpenDrawer(!openDrawer)}
														endIcon={<ArrowRightIcon />}
														style={{
															position: "absolute",
															zIndex: 1,
															right: 0,
															top: "3px",
														}}
													>
														Events
													</Button>
													{openDrawer && (
														<div className={classes.rootDrawer}>
															<div className={classes.wrapper}>
																<Slide
																	direction="left"
																	in={openDrawer}
																	mountOnEnter
																	unmountOnExit
																	// timeout={{
																	// 	exit: 500,
																	// }}
																>
																	<Paper elevation={1} className={classes.paper}>
																		<div>
																			<Button
																				size="small"
																				onClick={() => setOpenDrawer(!openDrawer)}
																				endIcon={<CloseIcon />}
																				style={{
																					position: "absolute",
																					zIndex: 1,
																					right: 0,
																					top: "3px",
																				}}
																			>
																				Close
																			</Button>
																		</div>
																		<Grid container>
																			<Grid
																				item
																				xs={12}
																				style={{
																					paddingBottom: 20,
																					justifyContent: "end",
																					display: "flex",
																				}}
																			>
																				<Button
																					color="secondary"
																					className={classes.button}
																					startIcon={<TimelineIcon />}
																					onClick={() => {
																						handleEventForm(true)
																						dispatch(setSelectedEvent({}))
																					}}
																				>
																					{t("timeline.addEvent")}
																				</Button>
																				<Button
																					color="secondary"
																					className={classes.button}
																					startIcon={<EventNoteIcon />}
																					onClick={() => {
																						dispatch(checkNameAlreadyExistFailed())
																						setOpenSaveDialog(true)
																					}}
																				>
																					{t("timeline.saveDataRange")}
																				</Button>
																				<Button
																					color="secondary"
																					className={classes.button}
																					startIcon={<ExportSVG width={18} height={18} />}
																					onClick={() => setOpenExportEvent(true)}
																				>
																					{t("timeline.export")}
																				</Button>
																			</Grid>

																			<Grid item xs={12}>
																				<>
																					<Tabs
																						className={classes.tabs}
																						value={panel}
																						onChange={handlePanelChange}
																						aria-label="Save date range and events"
																					>
																						<Tab
																							value="one"
																							label={t("event.events")}
																							{...a11yProps("one")}
																						/>
																						<Tab
																							value="two"
																							label={t("timeline.savedDateRanges")}
																							{...a11yProps("two")}
																						/>
																					</Tabs>

																					<TabPanel
																						value={panel}
																						index="one"
																						className={classes.tab}
																					>
																						<Events />
																					</TabPanel>
																					<TabPanel
																						value={panel}
																						index="two"
																						className={classes.tab}
																					>
																						<SavedSearchDateRange
																							refetchList={refetchList}
																							setSelectedGraphDateRange={
																								setSelectedGraphDateRange
																							}
																							initilaselectedDateRange={
																								initilaselectedDateRange
																							}
																							handleDateRangeChange={handleDateRangeChange}
																							dateRangeHandler={dateRangeHandler}
																						/>
																					</TabPanel>

																					{/**Modal Popup for tabs start*/}
																					<ModalPopup
																						title={
																							editEvent.id
																								? t("timeline.createEvent")
																								: t("timeline.editEvent")
																						}
																						open={openEventForm}
																						setOpen={handleEventForm}
																					>
																						<CreateEvent callback={handleOpenSaveEventDialog} />
																					</ModalPopup>

																					<SaveDateRangeDialog
																						open={openSaveDialog}
																						title={t("timeline.saveDialog.title")}
																						onClose={() => {
																							setOpenSaveDialog(false)
																						}}
																						selectedGraphDateRange={selectedGraphDateRange}
																					/>

																					<ModalPopup
																						title={"Export event"}
																						open={openExportEvent}
																						setOpen={setOpenExportEvent}
																						style={{
																							maxWidth: "1000px",
																							minWidth: "1000px",
																							marginTop: 0,
																						}}
																					>
																						<ExportEvent callback={setOpenExportEvent} />
																					</ModalPopup>
																					{/**Modal Popup for tabs end*/}
																				</>
																			</Grid>
																		</Grid>
																	</Paper>
																</Slide>
															</div>
														</div>
													)}
												</>
											)}
										</div>
									</div>
									<div
										style={{
											display: "flex",
											justifyContent: "center",
										}}
									>
										<div className={classes.grpahMainContainer}>
											{expandGraph ? (
												<Tooltip title={"Hide Graph"} placement="bottom" arrow>
													<ArrowUpIcon
														color="primary"
														className={classes.grpahExpandIcon}
														onClick={toggleExpandGraph}
													/>
												</Tooltip>
											) : (
												<Tooltip title={"Show Graph"} placement="bottom" arrow>
													<ArrowDownIcon
														color="primary"
														className={classes.grpahExpandIcon}
														onClick={toggleExpandGraph}
													/>
												</Tooltip>
											)}
										</div>
									</div>
								</Paper>
							</Grid>
						</Grid>

						<AllDocumentsList
							elementsFilter={elementsFilter}
							filtersButton={filtersButton}
							setDocumentslist={setDocumentslist}
							filterList={filterList}
							filterDate={filterDate}
							needToFilter={needToFilter}
							setNeedToFilter={setNeedToFilter}
							page={page}
							setPage={setPage}
							pageCount={pageCount}
							setPageCount={setPageCount}
							recordsPerPage={recordsPerPage}
							setRecordsPerPage={setRecordsPerPage}
							isEmailType={isEmailFilter}
							isAllDocsViewSelected={isAllDocsViewSelected}
							sortModel={sortModel}
							setSortModel={setSortModel}
							toRetainFilterLoading={toRetainFilters}
							selectedSearch={selectedSearch}
						/>
					</Grid>
				</Grid>
			</Grid>
			<ConfirmationDialog
				open={openDeleteConfirm}
				title={t("confirmationDialog.search.title")}
				message={t("confirmationDialog.search.message")}
				onConfirm={deleteSearchConfirm}
				onDismiss={deleteSearchConfirmDismiss}
				btnText={t("confirmationDialog.search.delete")}
			/>
			<ModalPopup
				className={classes.fileDeletedModal}
				title={
					<Typography variant="body1" style={{ fontWeight: 500 }}>
						This file has been deleted
					</Typography>
				}
				open={isFileDeleted}
				//setOpen={() => dispatch(setIsFileDeleted(false))}
				showClose={false}
				showDivider={false}
			>
				<FileDeleteModal
					content={t("deleteFile.messageList")}
					btnText={t("deleteFile.buttonTextList")}
					navigate={() => {
						dispatch(setIsFileDeleted(false))
						debouncedCallback()
					}}
				/>
			</ModalPopup>
		</Grid>
	)
}

export default React.memo(WithDrawer(PageDocuments))
